<template>
  <button
    :class="{'controls-subscribe': true, dark: isDark, [size]: size, disabled: isDisabled}"
    :disabled="isDisabled"
    @click="toggleSubscribe"
  ><IconShare /> <span>Share & Subscribe</span></button>
</template>

<script>
import Store from '../store'
import IconShare from '../assets/svg/share.svg'

export default {
  components: {IconShare},
  data () { return { store: Store } },
  computed: {
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size },
    isDisabled () {
      return !this.epi ||
        !this.epi.id ||
        this.epi.is_hidden
    }
  },
  methods: {
    toggleSubscribe () {
      this.store.setShowSubscribe(!this.store.state.showSubscribe)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';
@import '../assets/styles/breakpoints.scss';

button {
  background: none;
  border: none;
  color: $black-800;
  cursor: pointer;
  flex: 1;
  margin: 0;
  padding: 0;
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;

  @include font-xxs(700);

  @media (min-width: $bp_xs) {
    display: inline-block;
    margin-left: 20px;
    text-align: center;

    @include font-xs(700);
  }
  .simplecast-playlist & {
    span {
      display: none;
    }
  }
  .simplecast-player & {
    svg {
      display: none;
    }
  }
  @media (min-width: 465px) {
    .simplecast-playlist & {
      span {
        display: block;
      }
      svg {
        display: none;
      }
    }
  }
  .simplecast-playlist & {
    @media (max-width: 464px) {
      align-self: center;
      background: none;
      border-radius: 4px;
      border: solid 1px $black-800;
      color: $black-800;
      cursor: pointer;
      height: 20px;
      line-height: 18px;
      margin: 0;
      padding: 0;
      text-align: center;
      text-transform: uppercase;
      width: 32px;

      &.dark {
        border: solid 1px $white-000;
        color: $white-000;
      }
    }
  }
  &.size-mini {
    border-radius: 4px;
    border: solid 1px $black-800;
    color: $black-800;
    display: flex;
    justify-content: center;
    margin-left: 0;
    opacity: .2;
    transition: opacity .2s;
    width: 100%;

    &:hover {
      opacity: .95;
    }
    &.dark {
      border: solid 1px $white-000;
    }
    span {
      display: none;
    }
    svg {
      display: block;
    }
  }
  &.dark {
    color: $white-trans-700;

    @media (min-width: $bp_xs) {
      color: $white-000;
    }
    svg {
      fill: $white-trans-800;
    }
  }
  &.disabled {
    background-color: transparent;
    color: $grey-300;
    cursor: default;
    &.dark {
      color: $grey-700;
    }
  }
}
</style>
